import { Grid } from "@mui/material";
import React from "react";
import { getAssets } from "@unisearch/helpers";
import styles from "./get_details.module.scss";

export const UniPageAnalyticsGetDetails = () => {
  return (
    <section className={styles.section_details}>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>Get into the Details</h2>
            <p className={`${styles.sub_title} font-medium`}>
              Alongside broad overviews giving you the bird’s eye perspective of
              the patterns and trends in student engagement behaviour, you can
              also get into the nitty-gritty of the data for specific metrics.
            </p>
            <p className={`font-medium`}>
              Take a look at proportions of successful versus incomplete
              applications, student interest and engagement for programs across
              specialisations, study levels, tuition fees, etc., metrics from
              specific target markets, and more.
            </p>
          </Grid>

          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_get_details.png")}
                alt="Get details"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageAnalyticsGetDetails;
